import type { LegacyRiskGapStatus } from '@ctw/shared/api/fhir/models/risk-gap';
import { Tooltip } from '@ctw/shared/components/tooltip';
import { twx } from '@ctw/shared/utils/tailwind';
import { faCircleCheck as faCircleCheckRegular } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RISK_GAP_VALUES, type RiskGapStatus } from '@zeus-health/types';
import { useId } from 'react';

interface RiskGapInfoIconProps {
  className?: string;
  hide?: boolean;
  /** The info text that we display in the popover */
  info: string | undefined;
}

/** @returns the info popup value for the common icon */
export function infoForRiskGapIcon(
  status: RiskGapStatus | LegacyRiskGapStatus | undefined,
): string | undefined {
  if (
    status ===
    RISK_GAP_VALUES.MEASURE_REPORT.EXTENSION.RISK_GAP_STATUS_UPDATE.EXPECTED_TO_CLOSE_FIRST_PARTY
  ) {
    return 'First Party Data';
  }
  return '';
}

/**
 * Displays an icon with info tooltip for certain risk-gap related interfaces.
 * @returns nothing if info is an empty string or if hide param is true.
 */
export function RiskGapInfoIcon({ hide, info, className }: RiskGapInfoIconProps) {
  const id = useId();
  if (hide || !info) {
    return null;
  }
  return (
    <Tooltip content={info} id={id} className={className}>
      <FontAwesomeIcon
        icon={faCircleCheckRegular}
        className={twx('h-3.5 w-3.5 text-content-subtle')}
      />
    </Tooltip>
  );
}
